/**
 * Preferências de LAYOUT deste browser — do posto de trabalho, não da conta.
 *
 * Hoje guarda só se a coluna dos canais está recolhida. Vive em `localStorage`
 * pela mesma razão do `officePrefs`: quem recolhe a coluna fá-lo porque quer o
 * ecrã da chamada maior, e devolvê-la a cada F5 é obrigar a arrumar a casa
 * todos os dias. Não é dado de conta — o mesmo utilizador num portátil de 13"
 * e num monitor de 27" quer coisas diferentes, e é o ecrã que manda.
 *
 * Ler nunca rebenta: `localStorage` bloqueado (modo privado, permissões) ou um
 * valor corrompido devolvem o default em silêncio. Uma preferência não é dado
 * crítico — falhar a lê-la não pode partir o arranque da app.
 */

export interface LayoutPrefs {
  /** Coluna de canais recolhida à tira estreita (fica a seta para a trazer de volta). */
  sidebarCollapsed: boolean;
}

const KEY = "gv.layout.prefs";

export const DEFAULT_LAYOUT_PREFS: LayoutPrefs = { sidebarCollapsed: false };

export function loadLayoutPrefs(): LayoutPrefs {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return DEFAULT_LAYOUT_PREFS;
    const parsed = JSON.parse(raw) as Partial<LayoutPrefs>;
    return { sidebarCollapsed: Boolean(parsed.sidebarCollapsed) };
  } catch {
    return DEFAULT_LAYOUT_PREFS;
  }
}

export function saveLayoutPrefs(prefs: LayoutPrefs): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(prefs));
  } catch {
    // Sem persistência (modo privado): a escolha vale só esta sessão. Ok.
  }
}
